<template>
  <div class="lava-scene">
    <div class="lava-lamp" style="--height: 350; --width: calc(350/2.66666667)">
      <div class="lava-lamp__main">
        <div class="lava-lamp__glass">
          <div class="lava-lamp__lava">
            <svg>
              <ellipse
                class="blob blob--top"
                cx="35"
                cy="0"
                rx="35"
                ry="10"
              ></ellipse>
              <ellipse
                class="blob blob--bottom"
                cx="75"
                cy="270"
                rx="75"
                ry="10"
              ></ellipse>
              <circle
                class="blob"
                r="42.5"
                cx="64"
                cy="400"
                style="
                  --skewX: -3;
                  --skewY: 4;
                  --height: 85;
                  --speed: 35;
                  --delay: -3;
                  --direction: alternate-reverse;
                "
              ></circle>
              <circle
                class="blob"
                r="20"
                cx="50"
                cy="400"
                style="
                  --skewX: 2;
                  --skewY: -4;
                  --height: 40;
                  --speed: 41;
                  --delay: -7;
                  --direction: alternate-reverse;
                "
              ></circle>
              <circle
                class="blob"
                r="25"
                cx="79"
                cy="400"
                style="
                  --skewX: 5;
                  --skewY: 3;
                  --height: 50;
                  --speed: 16;
                  --delay: -2;
                  --direction: alternate-reverse;
                "
              ></circle>
            </svg>
          </div>
          <div class="lava-lamp__lava">
            <svg>
              <ellipse
                class="blob blob--top"
                cx="35"
                cy="0"
                rx="35"
                ry="10"
              ></ellipse>
              <ellipse
                class="blob blob--bottom"
                cx="75"
                cy="270"
                rx="75"
                ry="10"
              ></ellipse>
              <circle
                class="blob"
                r="41"
                cx="70"
                cy="400"
                style="
                  --skewX: -2;
                  --skewY: 0;
                  --height: 82;
                  --speed: 28;
                  --delay: -8;
                  --direction: alternate-reverse;
                "
              ></circle>
              <circle
                class="blob"
                r="24.5"
                cx="60"
                cy="400"
                style="
                  --skewX: -5;
                  --skewY: 4;
                  --height: 49;
                  --speed: 46;
                  --delay: -7;
                  --direction: alternate;
                "
              ></circle>
              <circle
                class="blob"
                r="43"
                cx="106"
                cy="400"
                style="
                  --skewX: 3;
                  --skewY: 2;
                  --height: 86;
                  --speed: 50;
                  --delay: -9;
                  --direction: alternate;
                "
              ></circle>
              <circle
                class="blob"
                r="22"
                cx="89"
                cy="400"
                style="
                  --skewX: 0;
                  --skewY: 2;
                  --height: 44;
                  --speed: 36;
                  --delay: -4;
                  --direction: alternate-reverse;
                "
              ></circle>
            </svg>
          </div>
          <div class="lava-lamp__lava">
            <svg>
              <ellipse
                class="blob blob--top"
                cx="35"
                cy="0"
                rx="35"
                ry="10"
              ></ellipse>
              <ellipse
                class="blob blob--bottom"
                cx="75"
                cy="270"
                rx="75"
                ry="10"
              ></ellipse>
              <circle
                class="blob"
                r="44"
                cx="45"
                cy="400"
                style="
                  --skewX: -5;
                  --skewY: 2;
                  --height: 88;
                  --speed: 48;
                  --delay: -5;
                  --direction: alternate-reverse;
                "
              ></circle>
              <circle
                class="blob"
                r="26"
                cx="15"
                cy="400"
                style="
                  --skewX: 4;
                  --skewY: 1;
                  --height: 52;
                  --speed: 19;
                  --delay: -10;
                  --direction: alternate-reverse;
                "
              ></circle>
            </svg>
          </div>
          <div class="lava-lamp__lava">
            <svg>
              <ellipse
                class="blob blob--top"
                cx="35"
                cy="0"
                rx="35"
                ry="10"
              ></ellipse>
              <ellipse
                class="blob blob--bottom"
                cx="75"
                cy="270"
                rx="75"
                ry="10"
              ></ellipse>
              <circle
                class="blob"
                r="36"
                cx="84"
                cy="400"
                style="
                  --skewX: 1;
                  --skewY: -4;
                  --height: 72;
                  --speed: 13;
                  --delay: -10;
                  --direction: alternate;
                "
              ></circle>
            </svg>
          </div>
        </div>
      </div>
      <div class="lava-lamp__base"></div>
    </div>
    <svg style="position: absolute; left: 100%">
      <defs>
        <filter id="goo">
          <feGaussianBlur
            in="SourceGraphic"
            stdDeviation="10"
            result="BLUR"
          ></feGaussianBlur>
          <feColorMatrix
            in="BLUR"
            mode="matrix"
            values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 18 -7"
            result="GOO"
          ></feColorMatrix>
          <feBlend in="SourceGraphic" in2="goo"></feBlend>
        </filter>
      </defs>
    </svg>
  </div>
</template>

<script>
export default {
  name: "LavaLamp",
};
</script>

<style scoped>
* {
  box-sizing: border-box;
}
body {
  background: #1c0136;
  min-height: 100vh;
}
.scene {
  align-items: center;
  display: flex;
  justify-content: center;
  width: 100vw;
  position: relative;
  height: 100vh;
  overflow-x: hidden;
}
img {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-69.5%, -26%);
  opacity: 0.2;
  height: 1300px;
}
.lava-lamp {
  height: calc(var(--height) * 1px);
  width: calc(var(--width) * 1px);
  position: relative;
}
.lava-lamp:after {
  content: "";
  height: 500px;
  width: 500px;
  position: absolute;
  background: radial-gradient(circle at 50% 50%, #19b5fe, transparent 60%);
  top: 45%;
  left: 50%;
  z-index: 4;
  transform: translate(-50%, -50%);
  filter: blur(10px);
  opacity: 0.5;
}
.lava-lamp:before {
  content: "";
  height: 25%;
  width: 300%;
  border-radius: 100%;
  background: radial-gradient(ellipse at 50% 50%, #19b5fe, transparent 60%);
  position: absolute;
  top: 85%;
  left: 50%;
  transform: translate(-50%, 0);
  opacity: 0.5;
  filter: blur(10px);
}
.lava-lamp__main {
  border-radius: 50% 50% 50% 50%/60% 60% 40% 40%;
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  z-index: 2;
}
.lava-lamp__main:after,
.lava-lamp__main:before {
  background: #000;
  content: "";
  height: 12%;
  left: 0;
  position: absolute;
  width: 100%;
}
.lava-lamp__main:after {
  top: 0;
}
.lava-lamp__main:before {
  bottom: 0;
  height: 26%;
}
.lava-lamp__glass {
  background: radial-gradient(circle at 50% 50%, #3a539b 25%, #19b5fe);
  border-radius: 50%/10%;
  overflow: hidden;
  height: 70%;
  left: 0;
  position: absolute;
  top: 10%;
  width: 100%;
  z-index: 2;
}
.lava-lamp__base {
  height: 20%;
  width: 100%;
  position: absolute;
  bottom: 0;
  overflow: hidden;
  border-radius: 0 0 50% 50%/0 0 35% 35%;
}
.lava-lamp__base:before {
  content: "";
  background: #000;
  border-radius: 50% 50% 50% 50%/60% 60% 40% 40%;
  position: absolute;
  top: -60%;
  height: calc(var(--height) * 1px);
  width: calc(var(--width) * 1px);
}
.lava-lamp__lava {
  border-radius: 50%/10%;
  height: 100%;
  overflow: hidden;
  position: absolute;
  width: 100%;
  filter: url("#goo");
}
.lava-lamp__lava svg {
  height: 280px;
  width: 150px;
}
.blob {
  -webkit-animation-delay: calc(var(--delay) * 1s);
  animation-delay: calc(var(--delay) * 1s);
  -webkit-animation-direction: var(--direction);
  animation-direction: var(--direction);
  -webkit-animation-duration: calc(var(--speed) * 1s);
  animation-duration: calc(var(--speed) * 1s);
  -webkit-animation-iteration-count: infinite;
  animation-iteration-count: infinite;
  -webkit-animation-name: blob;
  animation-name: blob;
  -webkit-animation-timing-function: linear;
  animation-timing-function: linear;
  fill: #29f1c3;
  transform-box: fill-box;
}
.blob--bottom,
.blob--top {
  -webkit-animation: none;
  animation: none;
}
.blob--top {
  -webkit-animation: sway 20s infinite linear;
  animation: sway 20s infinite linear;
}
@-webkit-keyframes sway {
  50% {
    transform: translate(50%, 0);
  }
}
@keyframes sway {
  50% {
    transform: translate(50%, 0);
  }
}
@-webkit-keyframes blob {
  from {
    transform: skew(calc(var(--skewX) * 1deg), calc(var(--skewY) * 1deg))
      translate(0, 0);
  }
  to {
    transform: skew(calc(var(--skewX) * 1deg), calc(var(--skewY) * 1deg))
      translate(0, calc((400 + (var(--height) * 2)) * -1px));
  }
}
@keyframes blob {
  from {
    transform: skew(calc(var(--skewX) * 1deg), calc(var(--skewY) * 1deg))
      translate(0, 0);
  }
  to {
    transform: skew(calc(var(--skewX) * 1deg), calc(var(--skewY) * 1deg))
      translate(0, calc((400 + (var(--height) * 2)) * -1px));
  }
}
</style>